import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadComissaoProdutor = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      minWidth: "30px",
      width: "30px",
      align: "left",
    },
    {
      title: "Código",
      align: "left",
      minWidth: "70px",
      width: "70px",
    },
    {
      title: "Ver comissão",
      minWidth: "80px",
      width: "80px",
      align: "left",
    },
    {
      title: "Operadora",
      minWidth: "120px",
      align: "left",
      width: "120px",
    },
    {
      title: "Administradora",
      minWidth: "140px",
      width: "140px",
      align: "left",
    },
    {
      title: "Modalidade",
      minWidth: "140px",
      width: "140px",
      align: "left",
    },
    {
      title: "Produtor",
      align: "left",
      width: "160px",
      minWidth: "160px",
    },
    {
      title: "Vitalício",
      minWidth: "120px",
      align: "center",
      width: "120px",
    },
    {
      title: "Função",
      align: "left",
      width: "60px",
    },
    {
      title: "Tipo",
      align: "left",
      width: "60px",
    },
    {
      title: "Vigência",
      minWidth: "120px",
      align: "center",
      width: "120px",
      infoTitle: "Comissão valida a partir desta data",
    },
    {
      title: "Ativa",
      minWidth: "80px",
      align: "center",
      width: "80px",
      infoTitle: "Comissão ativa ficara disponível para utilizar em contratos",
    },
    {
      title: "Info",
      align: "center",
      width: "50px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
